/* Vaste winkelwagenbalk op de productpagina.

   De balk voert zelf niets uit. De knop klikt de echte "In winkelwagen"-knop van de
   pagina aan, zodat variantkeuze, aantal en de winkelwagenlade blijven werken zoals
   ze zijn. Wat de balk wél doet is meekijken: prijs, uitverkocht-stand en de
   variantfoto worden gespiegeld vanaf de echte productsectie.

   De knoptekst wordt alléén overgenomen als de echte knop uitstaat (uitverkocht,
   niet leverbaar). Staat hij gewoon aan, dan houdt de balk zijn eigen twee labels:
   de volledige tekst op desktop, de korte op de telefoon. CSS bepaalt welke van de
   twee je ziet.

   Staat er geen koopknop op de pagina, dan haalt de balk zichzelf weg in plaats van
   een knop te tonen die niets doet. */

(function () {
  var balk = document.querySelector('[data-sticky-winkelwagenbalk]');
  if (!balk) return;

  var hoofdKnop = document.querySelector('#MainContent product-form button[name="add"]');
  if (!hoofdKnop) {
    balk.remove();
    return;
  }

  var knop = balk.querySelector('[data-swb-knop]');
  var status = balk.querySelector('[data-swb-status]');
  var eigenLabels = balk.querySelectorAll('.swb__label--lang, .swb__label--kort');
  var prijsVak = balk.querySelector('[data-swb-prijs]');
  var foto = balk.querySelector('[data-swb-foto]');
  var hoofdPrijs = document.querySelector('#MainContent [id^="price-"]');
  var formulier = hoofdKnop.closest('form');

  document.body.classList.add('swb-ruimte');

  knop.addEventListener('click', function () {
    hoofdKnop.click();
  });

  function spiegelKnop() {
    var uit = hoofdKnop.hasAttribute('disabled');
    knop.disabled = uit;

    var tekst = hoofdKnop.querySelector('span');
    if (uit && tekst && tekst.textContent.trim()) {
      status.textContent = tekst.textContent.trim();
      status.hidden = false;
      eigenLabels.forEach(function (el) {
        el.hidden = true;
      });
    } else {
      status.hidden = true;
      eigenLabels.forEach(function (el) {
        el.hidden = false;
      });
    }
  }

  spiegelKnop();
  new MutationObserver(spiegelKnop).observe(hoofdKnop, {
    attributes: true,
    childList: true,
    subtree: true,
  });

  /* Varianten: bij een wissel vervangt het thema de inhoud van het prijsblok. Dat is
     het betrouwbaarste moment om mee te lopen, want dan is het verborgen id-veld al
     bijgewerkt. Op een `change` van het formulier reageren gaat mis: dan is dat veld
     soms nog de oude variant. */
  var variantFotos = {};
  try {
    variantFotos = JSON.parse(balk.dataset.swbVarianten || '{}');
  } catch (e) {
    variantFotos = {};
  }

  function spiegelVariant() {
    if (hoofdPrijs) prijsVak.innerHTML = hoofdPrijs.innerHTML;

    if (!foto || !formulier) return;
    var idVeld = formulier.querySelector('input[name="id"]');
    if (idVeld && variantFotos[idVeld.value]) {
      foto.src = variantFotos[idVeld.value];
    }
  }

  if (hoofdPrijs) {
    new MutationObserver(spiegelVariant).observe(hoofdPrijs, {
      childList: true,
      subtree: true,
    });
  }
})();
